import React from 'react'
import Navbar from "./global-components/navbar-v3";
import BannerV5 from "./section-components/banner-v5";
import Footer from "./global-components/footer";
import { Link } from "react-router-dom";

const Engineering = () => {
  return (
    <>
            <Navbar CustomClass="ltn__header-transparent gradient-color-2" />
            <BannerV5
                headerTitle={"Engineering assignment writing"}
                typeWriterValue={[
                    "Put a stop to deadline pressure, and have your homework done  ",
                    "by an expert.",
                    // "thesis",
                    // "PROJECT REPORT",
                ]}
                smallText={
                    ""
                }
            />
            <div className="container mt-100 mb-100">
                <div className="row ltn__custom-gutter--- justify-content-center go-top mb-50">
                    <div className="col-lg-3 col-sm-6 col-12" >
                        <div className="ltn__feature-item ltn__feature-item-6 text-center bg-white  box-shadow-1 active">
                            <div className="ltn__feature-icon">
                                <img
                                    src={"assets/img/icons/icon-img/22.png"}
                                    alt="#"
                                />
                            </div>
                            <div className="ltn__feature-info">
                                <h3>
                                    <Link to="#">182 300+</Link>
                                </h3>
                                <h6>
                                    <Link to="#">DELIVERED ORDERS</Link>
                                </h6>
                                {/* <p>{data.discription}</p>
      <Link className="ltn__service-btn" to="/contact">
        Order now <i className="flaticon-right-arrow" />
      </Link> */}
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-sm-6 col-12" >
                        <div className="ltn__feature-item ltn__feature-item-6 text-center bg-white  box-shadow-1 active">
                            <div className="ltn__feature-icon">
                                <img
                                    src={"assets/img/icons/icon-img/22.png"}
                                    alt="#"
                                />
                            </div>
                            <div className="ltn__feature-info">
                                <h3>
                                    <Link to="#">5844 +</Link>
                                </h3>
                                <h6>
                                    <Link to="#">EXPERTS</Link>
                                </h6>
                                {/* <p>{data.discription}</p>
      <Link className="ltn__service-btn" to="/contact">
        Order now <i className="flaticon-right-arrow" />
      </Link> */}
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-sm-6 col-12" >
                        <div className="ltn__feature-item ltn__feature-item-6 text-center bg-white  box-shadow-1 active">
                            <div className="ltn__feature-icon">
                                <img
                                    src={"assets/img/icons/icon-img/22.png"}
                                    alt="#"
                                />
                            </div>
                            <div className="ltn__feature-info">
                                <h3>
                                    <Link to="#">4.9/5</Link>
                                </h3>
                                <h6>
                                    <Link to="#">CLIENT RATING</Link>
                                </h6>
                                {/* <p>{data.discription}</p>
      <Link className="ltn__service-btn" to="/contact">
        Order now <i className="flaticon-right-arrow" />
      </Link> */}
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-sm-6 col-12" >
                        <div className="ltn__feature-item ltn__feature-item-6 text-center bg-white  box-shadow-1 active">
                            <div className="ltn__feature-icon">
                                <img
                                    src={"assets/img/icons/icon-img/22.png"}
                                    alt="#"
                                />
                            </div>
                            <div className="ltn__feature-info">
                                <h3>
                                    <Link to="#">5+ Countries</Link>
                                </h3>
                                <h6>
                                    <Link to="#">Operated in 5+ Countries</Link>
                                </h6>
                                {/* <p>{data.discription}</p>
      <Link className="ltn__service-btn" to="/contact">
        Order now <i className="flaticon-right-arrow" />
      </Link> */}
                            </div>
                        </div>
                    </div>
                </div>
                <h4>Get in on the Action: Marketing assignment writing That You Control Yourself</h4>
                <p>At assignment writing , we work alongside our clients to create good papers. We offer a custom service of writers for hire who work in coordination with you, our client, to finish your marketing thesis. This coordination serves three separate purposes that we will outline below:</p>
                <ul>
                    <li>Quality of the work: When we talk about quality, we mean that the writing, the originality, the research, and the arguments all meet our high standards.</li>
                    <li>Relevance of the subject: Marketing thesis are by their nature current. By working one-on-one with the client, we make sure the work we produce adheres to your specific thesis, and that it is relevant in the wider field of marketing initiatives.</li>
                    <li>Reputation of the service: As an off-shoot of the last two purposes, a successful project helps us build our reputation. You’re reading this now, for example, because our good reputation has allowed for the dissemination of our promotions.</li>
                </ul>
                <p>Allow us to present our service.</p>
                <h4>Learn About Our Marketing assignment writing</h4>
                <p>Marketing has evolved to include a lot more than cold calling and poster boarding. Now, Google Adwords and Facebook Ads plays a huge role in online advertising. Meanwhile, online video platforms are being used as much or more than Google for simple “how to” searches. If you have a marketing plan thesis, even if it does not directly concern digital, it must make room for digital components. Event planning, for example, depends heavily on promotion through social media. When we sit down to begin work on your project, we do so with this kind of knowledge at the ready.</p>

                <h4>Who Will Write Your Marketing thesis?</h4>
                <p>Regardless of the type of marketing thesis you need, our experts are prepared for the most daunting tasks in this field. There’s a common misconception that marketing is narrowing down to merely selling the product, but in reality, it encompasses much more actions. So, in order to create a perfect marketing thesis, it is important to understand the main goal of marketing, various strategies, customer’s demand, and be able to develop appropriate marketing solutions. Luckily, our writers are highly skilled in this domain, capable of handling homework on digital marketing, consumer behavior, conducting Porter’s Five Forces Analysis, and much more.</p>
                <p>We are native English speaking writers from diverse backgrounds who share the common traits of being expert researchers and very good writers. You get to select the person who will work on your piece. You’ll get to communicate with this person as much as need be. Request unlimited revisions, discuss a certain point you think needs more work, etc. The window of opportunity is opened thanks to this personalized interaction.</p>
                <h4>Enjoy Affordability Of Our Marketing thesis</h4>
                <p>We should mention that we’re cheap when it comes to financial concerns. You’re a student, so yes, we’re cheap. We have discounts to make it cheaper. Head over to The thesis Writing to claim your discount today. Just remember that a marketing plan thesis banks on good writing, so when you buy our cheap service, you’re investing in high-quality written work.</p>
              

            </div>

            {/* <CallToActionV1 /> */}
            <Footer />
        </>
  )
}

export default Engineering
